import { faHandshake, faStar } from '@fortawesome/pro-light-svg-icons';

import { Card } from '@/components/ui/card.component';
import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export function FaqBanner() {
  return (
    <Card className="border-0 sm:border bg-transparent sm:bg-white px-0 sm:p-6">
      <Typography
        variant={TypographyVariant.BODY_TEXT}
        className="font-bold mb-4"
      >
        O que é a Medprev?
      </Typography>
      <Typography>
        Há mais de 25 anos, a Medprev tem o propósito de tornar o acesso à saúde mais simples e acessível.
      </Typography>
      <Typography>
        Oferecemos consultas presenciais, teleconsultas, exames de imagem, exames laboratoriais e até cirurgias, sempre com qualidade e preços justos.
      </Typography>
      <br />
      <Typography>
        Diferente de um plano de saúde, aqui você só paga pelo que realmente precisa, no momento em que precisar, sem mensalidades, sem taxas e sem complicações.
      </Typography>
      <Typography>
        Na Medprev é assim: pague quando usar e conte com a gente sempre que precisar.
      </Typography>

      <hr className="my-7" />

      <div className="flex items-start gap-2">
        <Icon icon={faStar} size="lg" className="text-gray-500" />
        <Typography
          variant={TypographyVariant.BODY_TEXT}
          className="font-bold mb-4"
        >
          Nosso diferencial
        </Typography>
      </div>
      <div className="ml-6 text-gray-700">
        <li>Acesso imediato - atendimento sem carência.</li>
        <li>
          Economia garantida - pague apenas pelo serviço que precisa, sem
          mensalidades ou taxas de adesão.
        </li>
      </div>
      <br />
      <Typography>
        Na Medprev, você paga somente pelo que utiliza, quando necessita.
      </Typography>

      <hr className="my-7" />

      <div className="flex items-start gap-2">
        <Icon
          icon={faHandshake}
          size="lg"
          className="text-gray-500"
        />
        <Typography
          variant={TypographyVariant.BODY_TEXT}
          className="font-bold mb-4"
        >
          Valores acessíveis
        </Typography>
      </div>
      <Typography>
        Graças às nossas parcerias, oferecemos serviços de saúde a preços
        reduzidos. Nossos parceiros compartilham o compromisso de proporcionar
        atendimento acessível e de qualidade.
      </Typography>
    </Card>
  );
}
